























































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Veicolo } from '@/data/models/veicolo.model';
import { List } from '@/data/models/list.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	}
})
export default class EditVeicolo extends Vue {
	@Prop() veicolo?: Veicolo;

	@Inject('CrudService') veicoloCrudService!: CrudService<Veicolo>;
	@Inject('CrudService') listCrudService!: CrudService<List>;

	newVeicolo!: Veicolo;
	loading!: boolean;

	constructor() {
		super();
		this.loading = false;
		this.newVeicolo = new Veicolo();
	}

	beforeMount() {
		if (this.veicolo) {
			if (this.veicolo.id) {
				// edit
				this.loadVeicolo(this.veicolo.id);
			} else {
				this.newVeicolo = new Veicolo();
			}
		}
	}

	loadVeicolo(id: number) {
		this.loading = true;
		this.veicoloCrudService
			.getEntity(Veicolo, 'vehicle', id)
			.then(result => {
				this.newVeicolo = result;
			})
			.catch(error => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger'
				});
			}).finally(() => (this.loading = false));
	}

	setUppercase(event: string) {
		this.newVeicolo.plate = event.toUpperCase();
	}

	submit() {
		this.$emit('submit', this.newVeicolo);
	}

}
